import { Box, Text, Code } from "@chakra-ui/react"

type ErrorAlertProps = {
  message: string
  traceId?: string | null
}

export default function ErrorAlert({ message, traceId }: ErrorAlertProps) {
  return (
    <Box mb="4" bg="red.700" px="3" py="2" borderRadius="md">
      <Text fontSize="sm" color="white" mb={traceId ? 1 : 0}>
        {message}
      </Text>
      {traceId && (
        <Text fontSize="xs" color="gray.300">
          TraceId:{" "}
          <Code fontSize="xs" bg="transparent" color="gray.300">
            {traceId}
          </Code>
        </Text>
      )}
    </Box>
  )
}
